import { Component } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { Constant } from 'src/app/shared/service/utils/contant';

@Component({
  selector: 'app-poids-pdc',
  standalone: false,
  templateUrl: './poids-pdc.component.html',
  styleUrl: './poids-pdc.component.scss'
})
export class PoidsPdcComponent {

  poidPdcItems: any = [];
  pdcData: any = []
  selectedPdc: any;
  isStart:boolean = true;
  constructor(
    private paramService: ParameterService,
    private fecthDataService: FecthDataService,
    private loader: NgxUiLoaderService,
    private messageService: MessageService,


  ) {

    this.getPdc();
  }





  getPdc() {
    this.paramService.getPdcItems().subscribe(
      (response: any) => {
        this.pdcData = response.data;
        //console.log("this.pdcData", this.pdcData);
      },
      (error) => {
        //console.log("une erreur est survenu", error);
      }
    );
  }
  getParamPdcPoid() {
    console.log("selectedPdc", this.selectedPdc);
    this.loader.start();
    this.isStart = false;
    this.paramService.getParamPdcPoid(this.selectedPdc.id).subscribe(
      (response: any) => {

        console.log("la réponse du  webservice", response);
        this.poidPdcItems = response.data;
        this.loader.stop();


      },
      (error: any) => {
        console.log("une erreur est survenu", error);
        this.loader.stop();
      }
    )
  }


  configurePdcPoids() {


    const requestData = {

      pdc_id: this.selectedPdc.id,
      data: this.poidPdcItems

    }
    this.loader.start();

    this.paramService.configurePdcPoids(requestData).subscribe(
      (response: any) => {

        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });

        this.loader.stop();
        console.log("une réposne ", response);

      },
      (error: any) => {
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error.message });

        this.loader.stop();
        console.log("une erreur esr survenu", error);

      }
    )
  }
}
